<template>
  <div class="questionCrudComp">
    <div>
      <label class="label_title" for="">ID</label>
      <input-comp :classInput="'input_grey'" :value="data.id.value" v-model="data.id.value" disabled/>
      <p></p>
    </div>
    <div>
      <label class="label_title" for="">Название</label>

      <!-- <input-comp :disabled="id" :classInput="'input_grey'" :value="data.name.value" v-model="data.name.value" v-bind:class="{'animated shake error_input': errors.name}" v-on:click.native="resetError('name')"/> -->
      <input-comp :classInput="'input_grey'" :value="data.name.value" v-model="data.name.value" v-bind:class="{'animated shake error_input': errors.name}" v-on:click.native="resetError('name')"/>

      <p class="p_err_min">{{errors.name}}</p>
    </div>
    <div>
      <label class="label_title" for="">Вопрос</label>
      <!-- <input-comp :disabled="id" :classInput="'input_grey'" :value="data.info.value" v-model="data.info.value" v-bind:class="{'animated shake error_input': errors.info}" v-on:click.native="resetError('info')"/> -->
      <input-comp :classInput="'input_grey'" :value="data.info.value" v-model="data.info.value" v-bind:class="{'animated shake error_input': errors.info}" v-on:click.native="resetError('info')"/>

      <p class="p_err_min">{{errors.info}}</p>
    </div>
    <div>
      <div class="div_answers_title">
        <div>
          <label class="label_title" for="">Ответы</label>
        </div>

        <!-- <button-comp v-if="!id" class="btn_answer" :classBtn="'btn_white_min'" :textBtn="'+'" :clickBtn="addAnswer"/> -->
        <button-comp class="btn_answer" :classBtn="'btn_white_min'" :textBtn="'+'" :clickBtn="addAnswer"/>

        <!-- <button-comp class="btn_answer" :classBtn="'btn_white_min'" :textBtn="'-'" :clickBtn="deleteAnswer" v-if="!id" :disabled="data.answers.value.length <= 2"/> -->
        <button-comp class="btn_answer" :classBtn="'btn_white_min'" :textBtn="'-'" :clickBtn="deleteAnswer" :disabled="data.answers.value.length <= 2"/>

      </div>
      <div class="div_answer" v-for="(answer, index) in data.answers.value" :key="index">

        <!-- <input-comp :disabled="id" :classInput="'input_grey'" :value="answer" v-bind:class="{'animated shake error_input': errors.answers}" v-on:click.native="resetError('answers')" v-model="data.answers.value[index]"/> -->
        <input-comp :classInput="'input_grey'" :value="answer" v-bind:class="{'animated shake error_input': errors.answers}" v-on:click.native="resetError('answers')" v-model="data.answers.value[index]"/>

      </div>
      <p class="p_err_min">{{errors.answers}}</p>
    </div>
    <div class="div_btns">

      <!-- <button-comp v-if="!id" :classBtn="'btn_orange_min'" :textBtn="'Сохранить'" :clickBtn="save"/> -->
      <button-comp :classBtn="'btn_orange_min'" :textBtn="'Сохранить'" :clickBtn="save"/>

      <button-comp :classBtn="'btn_orange_min'" v-if="id" :textBtn="'Удалить'" :clickBtn="remove"/>
    </div>
    <p class="p_err_main">{{errMain}}</p>
  </div>
</template>

<script>
export default {
  name: 'questionCrudComp',
  props: {
  },
  data: function () {
    return {
      required: ['id', 'name', 'info', 'answers'],
      moduleName: 'questions'
    }
  },
  beforeCreate () {
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: this.required })
  },
  components: {
  },
  computed: {
    id: function () { return this.$store.getters[`${this.moduleName}/getId`] },
    data: function () { return this.$store.getters[`${this.moduleName}/getOne`] },
    errMain: function () { return this.$store.getters[`${this.moduleName}/getErrMain`] },
    errors: function () { return this.$store.getters[`${this.moduleName}/getErrors`] }
  },
  methods: {
    save () {
      this.$store.dispatch(`${this.moduleName}/createOrUpdate`, { data: this.data, required: this.required })
    },
    remove () {
      this.$store.dispatch(`${this.moduleName}/delete`)
    },
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    },
    resetError (param) {
      this.$store.commit(`${this.moduleName}/setErrors`, { param: param, value: null })
    },
    addAnswer () {
      this.resetError('answers')
      this.data.answers.value.push(null)
    },
    deleteAnswer () {
      this.resetError('answers')
      this.data.answers.value.pop()
    }
  }
}
</script>

<style scoped lang="scss">

.questionCrudComp {
  width: 350px;
  margin: 32px auto 32px auto;
}
.div_btns {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr;
}
.btn_answer {
  width: 28px;
  margin-left: 5px;
}
.div_answers_title {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr auto auto;
}
.div_answer {
  margin-top: 10px;
  margin-bottom: 10px;
}

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
  .questionCrudComp{
    width: calc(100% - 32px);
  }
}
@media screen and (max-width: 320px){
  .signinComp label{
    margin: 0 0 10px 0;
  }
  .signinComp input{
    margin: 0 0 20px 0;
  }
  .signinComp button{
    margin: 12px 0 0 0;
  }
}

</style>
